import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Gallery.css";

export default function Gallery() {
  const [categories, setCategories] = useState([]); // MUST be array
  const [images, setImages] = useState([]);
  const [activeCategory, setActiveCategory] = useState("all");

  const API_BASE = "http://localhost/myapp-ks/api";

  // 🔹 Fetch categories
  useEffect(() => {
    axios
      .get(`${API_BASE}/fetch_categories.php`)
      .then((res) => {
        // ✅ Force array
        if (Array.isArray(res.data)) {
          setCategories(res.data);
        } else if (Array.isArray(res.data.data)) {
          setCategories(res.data.data);
        } else {
          setCategories([]);
        }
      })
      .catch(() => setCategories([]));
  }, []);

  // 🔹 Fetch images
  useEffect(() => {
    axios
      .get(`${API_BASE}/fetch_gallery.php?category_id=${activeCategory}`)
      .then((res) => {
        setImages(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => setImages([]));
  }, [activeCategory]);

  return (
    <div className="gallery-container">
      {/* CATEGORY BUTTONS */}
      <div className="category-tabs">
        <button
          className={activeCategory === "all" ? "active" : ""}
          onClick={() => setActiveCategory("all")}
        >
          Show All
        </button>

        {Array.isArray(categories) &&
          categories.map((cat) => (
            <button
              key={cat.id}
              className={activeCategory === cat.id ? "active" : ""}
              onClick={() => setActiveCategory(cat.id)}
            >
              {cat.category_name}
            </button>
          ))}
      </div>

      {/* IMAGE GRID */}
      <div className="gallery-grid">
        {images.length === 0 ? (
          <p>No images found</p>
        ) : (
          images.map((img) => (
            <div className="gallery-item" key={img.id}>
              <img
                src={`http://localhost/myapp/uploads/gallery/${img.image_name}`}
                alt=""
              />
            </div>
          ))
        )}
      </div>
    </div>
  );
}
